// 翻譯google excel =>
// https://docs.google.com/spreadsheets/d/1MiFoFFlWSmWZWPIq4Wv8gaPzoIFHeDVbn04yO_oS_BI/edit#gid=1102706463

const APP_CONFIG = {
  API_HOST: process.env.REACT_APP_API_HOST || '/web',
  version: process.env.REACT_APP_VERSION || 'v1.0.0(DEV)',
} as const;

export default APP_CONFIG;
